/* global System */
// register component(s) with react habitat

export default {
  PartnerList: () => System.import('./index'),
}
